<template>
	<div class="content">
		<div class="menu-right">
			<div class="title">
				<span>回收检测流程</span>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<div class="" v-for="(item1,index1) in item.list" :key="index1">
					<h4>{{item1.title}}</h4>
					<p>{{item1.text}}</p>
					<img v-if="item1.img" :src="item1.img" alt="派派回收">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			clauseList: [
				{
					title: '一、查看手机型号',
					list: [
						{
							title: '1.后盖-机身标贴-型号',
							text: '设置-关于本机-型号',
							// img: require()
						},
						{
							title: '2.查看手机版本内存、版本、IMEI等。',
							text: '',
							img: require('../assets/images/process/img_01.png')
						}
					]
				},
				{
					title: '二、手机外观检测',
					list: [
						{
							title: '1.充新机 ( 99新 )',
							text: '产品未拆封或未激活使用及所有原装配件和包装都在未使用。',
							img: require('../assets/images/process/img_02.png')
						},
						{
							title: '2.靓机 ( 95新 )',
							text: '产品屏幕完好，机身没有磕碰掉漆划痕或有细微使用痕迹,外观划痕,外壳中框划痕及肉眼不易见轻微一点',
							img: require('../assets/images/process/img_03.png')
						},
						{
							title: '3.小花机 ( 9成新 )',
							text: '产品外观有微划痕或掉漆没有明显磕碰掉漆，外观磕碰/掉漆，肉眼可见磕碰以及明显划痕2处以上（或一处明显磕碰大于3MM以上的）。',
							img: require('../assets/images/process/img_04.png')
						},
						{
							title: '4.大花机（8成新）',
							text: '外观有明显磕碰，明显掉漆，或磨损严重，有很多明显划痕。',
							img: require('../assets/images/process/img_05.png')
						},
						{
							title: '5.机身弯曲',
							text: '',
							img: require('../assets/images/process/img_06.png')
						}
					]
				},
				{
					title: '三、屏幕检测',
					list: [
						{
							title: '',
							text: '查看屏幕是否完好；如是否有屏幕破损、屏幕划痕或边角破损等情况，屏幕破损：屏幕有明显可见破损。',
							// img: require()
						}
					]
				},
				{
					title: '四、屏幕显示',
					list: [
						{
							title: '',
							text: '查看触摸是否正常、是否存在漏光、色差等现象；划动图标，检测触摸是否正常。',
							img: require('../assets/images/process/img_07.png')
						}
					]
				},
				{
					title: '五、物理按键检测',
					list: [
						{
							title: '',
							text: '分别对电源键，音量键，静音键，Home键进行检测，检测按键是否弹力正常，有无松动，缺损，功能是否能正常使用。',
							img: require('../assets/images/process/img_08.png')
						}
					]
				},
				{
					title: '六、功能检测',
					list: [
						{
							title: '1.触摸功能不正常：触摸屏乱跳，局部不灵以及整屏触摸不动。',
							text: '',
							img: require('../assets/images/process/img_09.png')
						},
						{
							title: '2.指南针以及定位是否正常:指南针不会随着手机的摆动而转动；或者无法稳定只想南面或者背面，地图无法快速定位等。',
							text: '',
							img: require('../assets/images/process/img_10.png')
						},
						{
							title: '3.陀螺仪：陀螺仪是否能根据手机倾斜角度随时变化。',
							text: '',
							img: require('../assets/images/process/img_11.png')
						},
						{
							title: '4.录音功能：录音是否正常有无杂音或无音。',
							text: '',
							img: require('../assets/images/process/img_12.png')
						},
						{
							title: '5.检测定位。打开定位功能，查看定位是否准确。',
							text: '',
							img: require('../assets/images/process/img_13.png')
						},
						{
							title: '6.相机，闪光灯功能检测：相机对焦是否正常，有无抖动现象，有无黑斑。',
							text: '',
							img: require('../assets/images/process/img_14.png')
						},
						{
							title: '7.WIFI/蓝牙检测：检测连接是否稳定同一环境下信号是否正常，是否能够正常连接。',
							text: '',
							img: require('../assets/images/process/img_15.png')
						},
						{
							title: '8.光线感应扬声器：能够根据环境光线的强弱可以自动调节，扬声器音量调到最大是否试听是否有杂音或音量小。',
							text: '',
							img: require('../assets/images/process/img_16.png')
						},
						{
							title: '9.指纹功能是否正常：指纹无法正常录入，功能缺失，无指纹项。',
							text: '',
							img: require('../assets/images/process/img_17.png')
						},
						{
							title: '10.检测账号，检查iCloud、Flyme等账号是否解除绑定。',
							text: '',
							img: require('../assets/images/process/img_18.png')
						},
						{
							title: '11.通话不正常：听筒送话以及插卡无信号无4G，距离感应能否正常使用，现象等问题。',
							text: '',
							img: require('../assets/images/process/img_19.png')
						},
						{
							title: '12.数据清理：深度清除手机数据，确保用户隐私不泄漏。',
							text: '',
							img: require('../assets/images/process/img_20.png')
						}
					]
				},
				{
					title: '七、手机硬件检测',
					list: [
						{
							title: '',
							text: '检查是否进水或维修（绝不拆机）',
						},
						{
							title: '1.维修检测',
							text: '查看维修标识是否完整，机身螺丝是否有划动痕迹',
							img: require('../assets/images/process/img_21.png')
						},
						{
							title: '2.进水检测',
							text: '查看防水标识是否变色，手机插口、机身是否有受潮、霉变等现象',
							img: require('../assets/images/process/img_22.png')
						},
						{
							title: '3.手机查看',
							text: '打开后盖，查看主板、电池的情况（仅打开后盖作检查，绝不拆机）',
							img: require('../assets/images/process/img_23.png')
						}
					]
				}
			]
		}
	},
}
</script>

<style scoped>
.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #FF6700;
	padding-bottom: 4px;
}

.menu-right p{
	font-size: 16px;
	line-height: 30px;
	color: #282828;
	margin-top: 20px;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #FF6800;
}

h4{
	margin-top: 20px;
}
</style>
